export const getCazaExpiryFromPersona = (persona) => {
    const licencias = persona?.licenciasCaza || [];
    if (!Array.isArray(licencias) || licencias.length === 0) return null;

    const sorted = licencias
        .filter((l) => l && l.fechaCaducidad)
        .sort((a, b) => new Date(b.fechaCaducidad) - new Date(a.fechaCaducidad));

    const top = sorted[0];
    if (!top) return null;

    const exp = new Date(top.fechaCaducidad);
    const today = new Date();
    const daysLeft = Math.ceil((exp - today) / 86400000);

    let status = "ok";
    if (daysLeft < 0) status = "expired";
    else if (daysLeft <= 30) status = "soon";

    return { dateISO: top.fechaCaducidad, daysLeft, status };
};

export const getLicArmasExpiryFromPersona = (persona) => {
    const licencias = persona?.licenciasArmas || [];
    if (!Array.isArray(licencias) || licencias.length === 0) return null;

    const sorted = licencias
        .filter((l) => l && !l.fechaIndefinida && l.fechaValidez)
        .sort((a, b) => new Date(b.fechaValidez) - new Date(a.fechaValidez));

    const top = sorted[0];
    if (!top) return null;

    const exp = new Date(top.fechaValidez);
    const today = new Date();
    const daysLeft = Math.ceil((exp - today) / 86400000);

    let status = "ok";
    if (daysLeft < 0) status = "expired";
    else if (daysLeft <= 30) status = "soon";

    return { dateISO: top.fechaValidez, daysLeft, status };
};
